define('home/views/ForumProfileView',[
    'underscore',

    'core/strings',

    'home/templates/forumView',

    'home/views/common/FetchableCollectionLayout',
    'home/views/common/TabbedView',

    'home/models/Session',

    'home/utils/backboneUtils',

    'home/views/RecommendationsModuleView',


    'home/views/ForumProfileCardCollectionView',
    'home/views/ForumCoverView',
    'home/views/ForumProfileRecentEmptyView',
    'home/views/ForumProfileTopCommentersEmptyView',
    'home/views/UserCollectionView',

    'home/mixins/withClickLinkTracking',
    'home/mixins/withLoginOverlay',
], function (
    _,

    strings,

    forumViewTemplate,

    FetchableCollectionLayout,
    TabbedView,

    Session,

    backboneUtils,

    RecommendationsModuleView,

    ForumProfileCardCollectionView,
    ForumCoverView,
    ForumProfileRecentEmptyView,
    ForumProfileTopCommentersEmptyView,
    UserCollectionView,

    withClickLinkTracking,
    withLoginOverlay
) {
    'use strict';

    var gettext = strings.get;

    var ForumProfileView = TabbedView.extend({
        defaultTab: 'recent',
        template: forumViewTemplate,

        regions: _.defaults({
            coverRegion: '[data-role=cover-area]',
            recommendedUsersModuleRegion: '[data-role=recommend-module][data-recommend-type=user]',
            recommendedForumsModuleRegion: '[data-role=recommend-module][data-recommend-type=forum]',
        }, TabbedView.prototype.regions),

        events: _.defaults({
            'click a[data-link-name]': 'trackClickLink',
        }, TabbedView.prototype.events),

        initialize: function () {
            TabbedView.prototype.initialize.apply(this, arguments);

            // ensure session user's following forums are fetched so that
            // following/followed forum button in ForumCoverView is displayed correctly
            var session = Session.get();
            session.loadPromise().then(function () {
                session.userProfile.forumsFollowing.ensureFetched();
            });
        },

        getTabView: function (activeTab) {
            var view;
            switch (activeTab) {
            case 'recent':
                view = new FetchableCollectionLayout({
                    model: this.model.recent,
                    collection: this.model.recent.get('items'),
                    fetchableCollectionView: ForumProfileCardCollectionView,
                    emptyView: ForumProfileRecentEmptyView,
                    infiniteScroll: true,
                });

                return view;
            case 'commenters':
                view = new FetchableCollectionLayout({
                    user: this.model.user,
                    model: this.model.mostLikedUsers,
                    collection: this.model.mostLikedUsers.get('items'),
                    fetchableCollectionView: UserCollectionView,
                    emptyView: ForumProfileTopCommentersEmptyView,
                    infiniteScroll: true,
                });
                view.$el.attr({
                    'class': 'card-wrap',
                });

                return view;
            }
        },

        getTrackingSection: function (activeTab) {
            switch (activeTab) {
            case 'recent':
                return 'recent_threads';
            case 'commenters':
                return 'top_commenters';
            }
        },

        renderCover: function () {
            var coverView = new ForumCoverView({ model: this.model.forum });

            // if cover re-renders, we need to show the correct tab as active
            coverView.listenTo(coverView, 'dom:refresh', _.bind(this.updateTabClasses, this));

            this.coverRegion.show(coverView);
        },

        onDomRefresh: function () {
            if (this.$(this.coverRegion.el).length)
                this.renderCover();

            this.recommendedUsersModuleRegion.show(
                RecommendationsModuleView.createUserRecommendedModuleView({ model: this.model.interestingUsers })
            );
            this.recommendedForumsModuleRegion.show(
                RecommendationsModuleView.createForumRecommendedModuleView({ model: this.model.interestingForums })
            );

            return TabbedView.prototype.onDomRefresh.apply(this, arguments);
        },

        getPageTitle: function () {
            var forum = this.model.forum;
            return backboneUtils.getPromiseFor(forum, 'name')
                .then(function (forumName) {
                    return strings.interpolate(gettext('%(forum)s · Conversations'), { forum: forumName });
                });
        },

        getMetaAttrs: function () {
            var forum = this.model.forum;
            return this.getPageTitle()
                .then(function (pageTitle) {
                    return {
                        title: pageTitle,
                        description: forum.get('description'),
                        image: forum.has('favicon') && forum.get('favicon').cache,
                        type: 'article',
                    };
                });
        },

        getPageTrackingParams: function () {
            var forum = this.model.forum;
            return this.getPageTitle().then(function (pageTitle) {
                return {
                    forum: forum.id,
                    title: pageTitle,
                };
            });
        },

        // TODO: Move Refresh functionality to RecommendationsModuleView for reusability!
        refreshRecommendedFeed: function () {
            this.model.popular.fetchItems({
                reset: true,
            });
        },
    });

    withClickLinkTracking.call(ForumProfileView.prototype);
    withLoginOverlay.call(ForumProfileView.prototype);

    return ForumProfileView;
});

